var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChincheta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87106 4.91061C3.55207 4.91061 2.77088 4.82217 2.01019 4.05424C1.04205 3.07664 1.17581 2.05384 1.18183 2.01085C1.19399 1.92732 1.23207 1.84969 1.29115 1.78926L1.70803 1.3623C1.98882 1.07574 2.64338 0.721256 3.44988 1.02194L3.45455 1.01728C3.47985 0.801464 3.55134 0.520184 3.74504 0.322674C3.94869 0.1146 4.22297 0 4.51764 0C4.87765 0 5.24061 0.16754 5.53848 0.471912C6.09379 1.03889 6.15484 1.79933 5.68415 2.28009C5.49082 2.4776 5.21507 2.55228 5.00171 2.57918L4.99287 2.58839C5.29159 3.40865 4.94595 4.07611 4.66688 4.36046L4.25073 4.7868C4.18882 4.8503 4.10702 4.89133 4.01907 4.90336C4.00986 4.90447 3.95754 4.9111 3.87094 4.9111V4.91086L3.87106 4.91061Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61632 4.44458C1.52199 4.34939 1.43662 4.25346 1.35887 4.15802L0.113866 5.42599C-0.0400398 5.58272 -0.0375832 5.83489 0.119148 5.9888C0.19653 6.06483 0.297251 6.10278 0.397971 6.10278C0.498692 6.10278 0.604079 6.06311 0.682076 5.98352L1.92118 4.72156C1.8196 4.63865 1.71753 4.54653 1.61657 4.44446H1.61632V4.44458Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChincheta);
export default __webpack_public_path__ + "static/media/chincheta.a47a3fffca9763424599c7c2d86c436d.svg";
export { ForwardRef as ReactComponent };